<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <m-search-item label="型号名称">
                    <c-input name="model_name" maxlength="20"></c-input>
                </m-search-item>
                <m-search-item label="状态">
                    <c-checkbox-group name="status" :options="disableEnableDic"></c-checkbox-group>
                </m-search-item>
                <m-search-item label="分类">
                    <c-select name="category_id" v-model="categoryId" async @search="searchCategory"></c-select>
                </m-search-item>
                <m-search-item label="品牌">
                    <c-select name="brand_id" v-model="brandId" async @search="searchBrand"></c-select>
                </m-search-item>
                <m-search-item label="系列">
                    <c-select name="series_id" v-model="seriesId" async @search="searchSeries"></c-select>
                </m-search-item>
                <m-search-item label="备注">
                    <c-input name="remark" maxlength="20"></c-input>
                </m-search-item>
                <m-search-item label="添加时间" colspan="2">
                    <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                </m-search-item>
            </m-search>

            <m-operate>
                <c-button color="main" v-if="auth('b_model_edit')" prepend-icon="tf-add"
                          @click="$refs.modelEdit.open()">添加型号
                </c-button>
                <c-button v-if="auth('b_model_template_config')" :hollow="true" @click="batchTemplateConfig">
                    批量配置质检模板
                </c-button>
            </m-operate>

            <c-table ref="list" height="grow" :paging="true">
                <c-table-column
                        type="selector"
                        width="32"
                ></c-table-column>

                <c-table-column label="ID" name="id" width="80" fixed="left"></c-table-column>

                <c-table-column
                        label="型号名称"
                        name="model_name"
                        width="150"
                        fixed="left"
                >
                </c-table-column>

                <!-- 是否启用 -->
                <c-table-column
                        label="状态"
                        name="status"
                        width="80"
                        fixed="left"
                >
                    <template #default="{data}">
                        <c-switch v-if="auth('b_model_edit')" v-model="data.status" :state-value="[1, 0]"
                                  :state-text="['启用','禁用']"
                                  @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
                        <c-state v-else dict="disableEnableDic" :value="data.status"></c-state>
                    </template>
                </c-table-column>


                <c-table-column
                        label="系列"
                        name="series_name"
                        width="150"
                >
                </c-table-column>


                <c-table-column
                        label="品牌"
                        name="brand_name"
                        width="100"
                >
                </c-table-column>

                <c-table-column
                        label="分类"
                        name="category_name"
                        width="80"
                >
                </c-table-column>

                <c-table-column
                        label="网络型号"
                        name="net_model"
                        width="100"
                >
                </c-table-column>

                <c-table-column
                        label="备注"
                        name="remark"
                        width="150"
                >
                    <template #default="{data}">
                        <span v-if="data.remark">{{ data.remark }}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="添加人"
                        name="create_user_name"
                        width="80"
                >
                </c-table-column>

                <c-table-column
                        label="添加时间"
                        name="create_time"
                        width="130"
                >
                </c-table-column>

                <c-table-column
                        label="排序"
                        type="sort"
                        fixed="right"
                        @handle="sortHandle">
                </c-table-column>

                <c-table-column
                        type="button"
                        label="操作"
                        width="175"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_model_channel_set')" icon="tf-related" @click="$refs.channelRefEdit.open(data,data.model_name,'model')">渠道映射</c-table-button>
                        <c-table-button v-if="auth('b_model_channel_sku_config')" icon="tf-setting" @click="$refs.modelSkuConfigEdit.open(1,data)">B端SKU配置</c-table-button>
                        <c-table-button v-if="auth('b_model_channel_sku_config')" icon="tf-setting" @click="$refs.modelSkuConfigEdit.open(0,data)">C端SKU配置</c-table-button>
                        <c-table-button v-if="auth('b_model_template_config')" icon="tf-setting" @click="$refs.modelTemplateConfigEdit.open(data.id,data)">配置质检模板</c-table-button>
                        <c-table-button v-if="auth('b_model_edit')" icon="tf-edit" @click="$refs.modelEdit.open(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_model_edit')" icon="tf-trash" color="red" @click="removebrand(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
            <!--添加/编辑型号信息弹窗-->
            <model-edit ref="modelEdit" @resolve="$refs.list.update()"></model-edit>
            <!--设置关联渠道信息弹窗-->
            <channel-ref-edit ref="channelRefEdit" @resolve="$refs.list.update()"></channel-ref-edit>
            <!--配置型号SKU配置弹窗-->
            <model-sku-config-edit ref="modelSkuConfigEdit" @resolve="$refs.list.update()"></model-sku-config-edit>
            <!--配置型号质检模板弹窗-->
            <model-template-config-edit ref="modelTemplateConfigEdit"
                                        @resolve="$refs.list.update()"></model-template-config-edit>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import modelEdit from "@/pages/spv/model_edit.vue";
import channelRefEdit from "@/pages/spv/channel_ref_edit.vue";
import modelSkuConfigEdit from "@/pages/spv/module_sku_config.vue";
import modelTemplateConfigEdit from "@/pages/spv/modelt_template_config_edit.vue";

export default {
    components: {
        modelEdit,
        channelRefEdit,
        modelSkuConfigEdit,
        modelTemplateConfigEdit
    },
    computed: {
        // 获取dictName选项数据
        ...mapState(['disableEnableDic'])
    },

    props: {
        type: String
    },

    watch: {
        //选择的分类变化，清除已选品牌
        categoryId() {
            this.brandId = 0;
            this.seriesId = 0;
        },
        //选择的分类变化，清除已选品牌
        brandId() {
            this.seriesId = 0;
        }
    },

    data() {
        return {
            categoryId: 0,        //已选中的分类ID
            brandId: 0,           //已选中的品牌ID
            seriesId: 0           //已选中的系列ID
        }
    },

    mounted() {
        this.searchHandle();
    },

    methods: {
        /********搜索************/
        searchHandle(data) {
            if (!data) {
                data = {};
            }
            this.$refs.list.load({
                url: '/spu/model/list',
                data
            });
        },

        /*******搜索分类*****************/
        searchCategory(keyword, resolve) {
            this.request({
                url: '/spu/category/options',
                data: {
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },

        /*******搜索品牌*****************/
        searchBrand(keyword, resolve) {
            this.request({
                url: '/spu/brand/options',
                data: {
                    category_id: this.categoryId,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },

        /*******搜索系列*****************/
        searchSeries(keyword, resolve) {
            this.request({
                url: '/spu/series/options',
                data: {
                    category_id: this.categoryId,
                    brand_id: this.brandId,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },

        /******启禁用*********/
        stateHandle(state, next, data) {
            this.request({
                url: '/spu/model/edit/status',
                data: {
                    id: data.id,
                    status: state ? 2 : 1   //1：启用； 2：禁用
                },
                success: () => {
                    this.$message({
                        message: '操作成功',  // 提示内容,
                        type: 'success'
                    });
                    next();
                }
            })
        },

        /******删除型号***********/
        removebrand(data) {
            this.$confirm({
                message: '确认删除型号【' + data.brand_name + '】？删除后不可恢复',  // 提示内容,
                // buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/spu/model/remove',
                        data: {
                            id: data.id
                        },
                        loading: true,
                        success: data => {
                            this.$message({
                                message: '删除成功',  // 提示内容,
                                type: 'success'
                            });
                            this.$refs.list.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {
                },  // 取消按钮回调
            });
        },

        /********************排序**************************/
        sortHandle(row, type, next) {
            this.request({
                url: '/spu/model/sort',
                data: {
                    id: row.data.id,
                    type: ['top', 'bottom'].includes(type) ? type : '',
                    id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
                    id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
                },
                loading: true,
                success: data => {
                    // next();
                    this.$refs.list.update();
                }
            });
        },

        /****批量配置质检模板***/
        batchTemplateConfig() {
            var ids = [];
            this.$refs.list.getData('selected').forEach(item => {
                ids.push(item.id);
            });
            if (ids && ids.length > 0) {
                this.$refs.modelTemplateConfigEdit.open(ids, null);
            } else {
                this.$message({
                    message: '请选择至少一条型号数据',  // 提示内容,
                    type: 'warn'
                });
            }
        },
    }
}
</script>

<style lang="stylus" scoped>
</style>